import {
  TrendUp,
  Warning,
  CheckCircle,
  PauseCircle,
  type Icon,
} from "@phosphor-icons/react";
import type { GoalStatus } from "../../lib/goalPageDisplay";

/**
 * Phosphor icon per goal display-status, rendered inside the status pill (table
 * + card). Kept in the component layer — goalPageDisplay.ts is a PURE,
 * React-free module and must not import icon components.
 */
export const GOAL_STATUS_ICONS: Record<GoalStatus, Icon> = {
  on_track: TrendUp,
  off_track: Warning,
  complete: CheckCircle,
  paused: PauseCircle,
};
